"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataValidator = void 0;
const ts_types_1 = require("@waves/ts-types");
const validators_1 = require("./validators");
const dataScheme = {
    type: validators_1.isEq(ts_types_1.TRANSACTION_TYPE.DATA),
    senderPublicKey: validators_1.isPublicKey,
    version: validators_1.orEq([undefined, 0, 1, 2]),
    data: (data) => validators_1.isArray(data) &&
        data.every(item => validators_1.isValidData(item) || validators_1.isValidDeleteRequest),
    fee: validators_1.isNumberLike,
    timestamp: validators_1.isNumber,
    proofs: validators_1.ifElse(validators_1.isArray, validators_1.defaultValue(true), validators_1.orEq([undefined])),
};
exports.dataValidator = validators_1.validateByShema(dataScheme, validators_1.getError);
//# sourceMappingURL=data.js.map